export const rulesViolated = {
    moneyLaundry: 'Money laundering',
    fraud: 'Fraud',
    forgery: 'Forgery',
    theft: 'Theft',
    secondOffence: 'Other offence',
    dontKnow: 'Don\'t know',
};
